import { createFileRoute } from '@tanstack/react-router';

import CarfTransmissionsPageContainer from '../../components/transmissions/CarfTransmissionsPageContainer';
import LoadingPage from '../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute('/_authenticated/submissions')({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: CarfTransmissionsPageContainer,
  staticData: {
    configPageId: 'submissions',
    meta: {
      title: 'Submissions | Ledgible',
    },
  },
});
